<script>
	export let id = "cb";
	export let name = null;
	export let label = "";
	export let value = null;
	export let checked = null;
	export let required = null;
	export let disabled = null;
	export let validator = null;
	export let validatorValue = null;
	export let validatorMessage = null;
	export let validatorTarget = null;
</script>

<input
	type="checkbox"
	on:change
	bind:checked
	{value}
	{id}
	{name}
	data-validator={validator}
	data-validator-value={validatorValue}
	data-bouncer-message={validatorMessage}
	data-bouncer-target={validatorTarget}
	{required}
	{disabled} />
<label for={id}>
	{@html label}
	{#if required}
		<span class:isrequired={required}>*</span>
	{/if}
</label>

<style>
	label span.isrequired {
		color: var(--color-error);
		left: 4px;
		position: relative;
		font-size: 1.2em;
	}

	/* Base for label styling */
	[type="checkbox"]:not(:checked),
	[type="checkbox"]:checked {
		position: absolute;
		left: -9999px;
	}

	[type="checkbox"]:not(:checked) + label,
	[type="checkbox"]:checked + label {
		position: relative;
		padding-left: 2.95em;
		cursor: pointer;
		line-height: 1.8rem;
	}

	/* checkbox aspect */
	[type="checkbox"]:not(:checked) + label:before,
	[type="checkbox"]:checked + label:before {
		content: "";
		position: absolute;
		top: 2px;
		left: 0;
		width: 24px;
		height: 24px;
		border: 1px solid var(--color-border);
		background: #fff;
	}

	/* checkbox aspect */
	[type="checkbox"]:checked + label:before {
		content: "";
		border: 1px solid var(--color-primary);
	}

	/* checked mark aspect */
	[type="checkbox"]:checked + label:after {
		content: "";
		position: absolute;
		top: 5px;
		left: 8px;
		font-size: 1.4em;
		transition: all 0.2s;
		border-bottom: 2px solid var(--color-primary);
		border-right: 2px solid var(--color-primary);
		transform: rotate(35deg);
		width: 7px;
		height: 14px;
	}
	[type="checkbox"]:disabled:checked + label:after {
		border-bottom: 2px solid var(--color-border);
		border-right: 2px solid var(--color-border);
	}

	/* disabled checkbox */
	[type="checkbox"]:disabled:not(:checked) + label:before,
	[type="checkbox"]:disabled:checked + label:before {
		border-color: var(--color-primary);
	}

	[type="checkbox"]:disabled:checked + label:after {
		color: #999;
	}

	[type="checkbox"]:disabled + label {
		cursor: default;
	}

	/* hover style just for information */
	[type="checkbox"]:disabled:not(:checked) + label:before,
	[type="checkbox"]:disabled:checked + label:before {
		border-color: #ccc;
		background-color: #ddd;
	}
</style>
